import * as d3 from 'd3';
import $ from 'jquery';

export function addMap(map, data, stores, floorId, activeStoreSpaceId, rotation) {

  map = d3.select(map);

  var xmlobject;
  for(var floor in data){
    if(data[floor].floorId==floorId){
      xmlobject = data[floor].map;
    }
  }

  var xml = xmlobject,
      xmlDoc = $.parseXML(xml),
      $xml = $(xmlDoc),
      $svg = $xml.find('svg');

  var paths = $svg.children('path');
  var groups = $svg.children('g');

  // Add layers in z-order: base (bottom) first, then stores, and lastly map-overlays (top)
  const upperLevel = map.append('g').attr('id', 'svgmap__container').attr('transform', 'rotate('+rotation+')');
  var base = upperLevel.append('g').attr('id', 'base');
  var storespaces = upperLevel.append('g').attr('id', 'stores');
  var mapOverlays = upperLevel.append('g').attr('id', 'map-overlays');

  $.each(paths, function(i, path){

    if (typeof path.id == 'undefined' || path.id == ''){
      base
        .append('path')
        .attr('d', path.getAttribute('d'))
        .attr('fill', path.getAttribute('fill'))
        .attr('fill-opacity', path.getAttribute('fill-opacity'))
        .attr('stroke', path.getAttribute('stroke'));
    }else{
      if(path.id == activeStoreSpaceId){
        path.setAttribute('class', 'selected');
      }

      storespaces
        .append('path')
        .attr('id', path.id)
        .attr('class', path.getAttribute('class'))
        .attr('d', path.getAttribute('d'))
        .attr('fill', path.getAttribute('fill'))
        .attr('fill-opacity', path.getAttribute('fill-opacity'))
        .attr('stroke', path.getAttribute('stroke'))
        .attr('stroke-opacity', path.getAttribute('stroke-opacity'));
    }
  });

  $.each(groups, function(i, group) {
    mapOverlays.node().appendChild(document.importNode(group, true));
  });
}

